import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/reset.scss";
import { initI18n } from "./i18n";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/configureStore";

const root = ReactDOM.createRoot(document.getElementById("root"));

initI18n("/auth/rest/i18n/{{lng}}/{{ns}}").then(() => {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
});
